import Description from "../Description";

function AdminDescription(){
    return(
        <div>
            <Description title="Welcome Admin!" text="In this section you can manage everything related to the management of data of the different users: Beneficiaries, Volunteers and Donors" imagen="https://st5.depositphotos.com/16122460/65943/i/450/depositphotos_659436488-stock-photo-cute-girl-using-computer-at.jpg" descripImg="description component img"/>
        </div>
    )
}

export default AdminDescription;